module.exports = __webpack_public_path__ + "img/Number=107.bc0af178.png";